import { getType } from '../client-data/get-type';

/**
 * @returns plan type or null if it is of default type.
 */
export const getPlanType = plan => getType(plan == null ? void 0 : plan.clientData);
//# sourceMappingURL=get-plan-type.js.map